// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YJRX","left":"styles_left__2lUsW"};